import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";
import type { Company, UsageResponse, SingleResponse } from "./types";

export function useMyCompany() {
  return useQuery({
    queryKey: ["company", "me"],
    queryFn: () => apiFetch<SingleResponse<Company>>("/api/v1/companies/me"),
  });
}

export function useMyUsage() {
  return useQuery({
    queryKey: ["company", "usage"],
    queryFn: () => apiFetch<SingleResponse<UsageResponse>>("/api/v1/companies/me/usage"),
  });
}
